import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Stamps every outgoing request with:
 *   - Client-Type: WebApp   so both P&D and Telemetry auth handlers identify web requests
 *   - withCredentials: true so the browser sends the HttpOnly session cookie cross-origin
 *                          (required for direct Telemetry API calls from the web app)
 */
export const authInterceptor: HttpInterceptorFn = (req, next) =>
  next(req.clone({ setHeaders: { 'Client-Type': 'WebApp' }, withCredentials: true }));
